import CountHOC from 'platform/react/hoc/pubsub/count'

/**
 * Subbed version of the {@link CountWidget} that prepares
 * `count` so that it can be used with {@link CountHOC}.
 *
 * @param {React.Element} Component
 * @returns {React.Element}
 */
const SubbedCountWidget = Component => (props) => {
  const count = {
    options: {
      [props.documentType]: { [props.documentType]: null },
    },
    ref: props?.events?.onSubscription?.(null),
    handler: props.events?.onPublication,
  }

  return (
    <Component
      count={count}
      {...props}
    />
  )
}

export default Component => SubbedCountWidget(CountHOC(Component))
